import { render, staticRenderFns } from "./AxAppFailureReload.vue?vue&type=template&id=be8fe98c&scoped=true&"
import script from "./AxAppFailureReload.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureReload.vue?vue&type=script&lang=ts&"
import style0 from "./AxAppFailureReload.vue?vue&type=style&index=0&id=be8fe98c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8fe98c",
  null
  
)

export default component.exports